<main id="main-container">
    <swiper-container id="main-carousel" class="swiper" slides-per-view="1" pagination="true" navigation="true" loop speed=500 autoplay>
        <swiper-slide>
            <picture>
                <source srcset="assets/mobile/slide1-m4t.jpg" media="(max-width: 768px)">
                <img class="slider-img" src="assets/slide1-m4t.jpg"  alt="Matrice 4T">
            </picture>
            <div class="swiper-slide-text">
                <h2 style="display: none">Matrice 4 Series</h2>
                <img class="swiper-logo swiper-logo-xs" src="assets/logos/matrice-4-logo.svg" alt="">
                <p>La era del vuelo inteligente</p>
                <div class="swiper-slide-text-button-box">
                    <div class="swiper-slide-text-button"><span><a href="/products/matrice-4">Más información</a></span></div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <picture>
                <source srcset="assets/mobile/slide2-m400.jpg" media="(max-width: 768px)">
                <img class="slider-img" src="assets/slide2-m400.jpg"  alt="Matrice 400">
            </picture>
            <div class="swiper-slide-text">
                <img class="swiper-logo swiper-logo-s" src="assets/logos/matrice-400-logo.svg" alt="">
                <h2 style="display:none">Matrice 400</h2>
                <p>Ingeniería de excelencia, diseño versátil</p>
                <div class="swiper-slide-text-button-box">
                    <div class="swiper-slide-text-button"><span><a href="/products/matrice-400">Más información</a></span></div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <picture>
                <source srcset="assets/mobile/slide3-dock.jpg" media="(max-width: 768px)">
                <img class="slider-img" src="assets/slide3-dock.jpg"  alt="Dock">
            </picture>
            <div class="swiper-slide-text">
                <h2 style="display: none">Dock 3</h2>
                <img class="swiper-logo swiper-logo-s" src="assets/logos/dock3-logo.svg" alt="">
                <p>Ahora, todo en uno</p>
                <div class="swiper-slide-text-button-box">
                    <div class="swiper-slide-text-button"><span><a href="/products/dock3">Más información</a></span></div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <picture>
                <source srcset="assets/mobile/slide4-fh.png" media="(max-width: 768px)">
                <img class="slider-img" src="assets/slide4-fh.jpg"  alt="FlightHub">
            </picture>
            <div class="swiper-slide-text">
                <h2 style="display: none">FlightHub 2</h2>
                <img class="swiper-logo swiper-logo-s" src="assets/logos/fh-logo.svg" alt="">
                <p>Descubre la nube, descubre la inteligencia</p>
                <div class="swiper-slide-text-button-box">
                    <div class="swiper-slide-text-button"><span><a href="/products/fh2">Más información</a></span></div>
                </div>
            </div>
        </swiper-slide>
        <swiper-slide>
            <picture>
                <source srcset="assets/mobile/slide5-terra.jpg" media="(max-width: 768px)">
                <img class="slider-img" src="assets/slide5-terra.jpg"  alt="Terra">
            </picture>
            <div class="swiper-slide-text">
                <h2 style="display: none">DJI Terra</h2>
                <img class="swiper-logo swiper-logo-s" src="assets/logos/terra-logo.svg" alt="">
                <p>Digitaliza el mundo</p>
                <div class="swiper-slide-text-button-box">
                    <div class="swiper-slide-text-button"><span><a href="/products/terra">Más información</a></span></div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>

    <app-updates></app-updates>

    <app-public-security></app-public-security>
    <app-private-security></app-private-security>
    <app-inspections></app-inspections>
    <app-contact-form-compact></app-contact-form-compact>
</main>